import React, {useState} from 'react';
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row} from 'reactstrap';
import "./index.css";
import PropTypes from "prop-types";
import assets from "../../../../../util/assets";
import {formattedPrice} from "../../../../../util/utility";

const isDisable = (item, contentType) => {
    if (contentType === "picture") {
        return item.hasOwnProperty("videos") && item.videos.length > 0
    } else {
        return item.hasOwnProperty("pictures") && item.pictures.length > 0
    }
}

const contentCount = (item) => {
    let length = 0;
    if (item.hasOwnProperty("videos") && item.videos.length > 0) {
        length = item.videos.length;
        return length === 1 ? `includes ${length} video` : `includes ${length} videos`;
    } else if (item.hasOwnProperty("pictures") && item.pictures.length > 0) {
        length = item.pictures.length;
        return length === 1 ? `includes ${length} picture` : `includes ${length} pictures`;
    } else {
        return 'empty';
    }
}
const SelectGalleryModal = (props) => {
    const [galleryId, setGalleryId] = useState(-1);
    const [gallery, setGallery] = useState({});

    return (
        <Modal isOpen={props.isOpen}>
            <ModalHeader className="border-0 " id="upload-file-modal">
                <span className="text-center mb-2 modal-container-title">
                    Select Gallery
                </span>
                <img src={assets.broadcast.cross}
                     alt={"cross icon"}
                     onClick={() => {
                         props.toggle();
                     }}/>
            </ModalHeader>
            <ModalBody className="justify-content-center">
                <div className="select-gallery-modal-create-new-gallery-ghost-btn" onClick={()=>{
                    props.setCreateGalleryModal(true);
                }}>
                    <img src={assets.clipstore.plus} alt="create new gallery"/>
                    <span className="select-gallery-modal-create-new-gallery-ghost-text">Create new gallery</span>
                </div>
                {
                    props.gallery && props.gallery.map((item, index) => {

                        return (
                            <div className="form-group select-gallery-modal-gallery-item"
                                 key={`select-gallery-modal-gallery-item-${index}`}>
                                <label className="custom-radio-btn-container">
                                    <div className="display-flex-space-between">
                                        <span>
                                            {item.title}
                                            <span className="custom-radio-btn-container-italic">
                                                ({item.pricing.type === "free" ? "FREE" : formattedPrice(item.pricing.price)})
                                            </span>
                                        </span>
                                        <span className="custom-radio-btn-container-italic">{contentCount(item)}</span>
                                        <input type="radio"
                                               name="radio"
                                               value={item.id}
                                               disabled={isDisable(item, props.contentType)}
                                               onClick={() => {
                                                   setGalleryId(item.id)
                                                   setGallery(item)
                                               }}/>
                                        <span className="checkmark"></span>
                                    </div>
                                </label>
                            </div>
                        )
                    })
                }
            </ModalBody>
            <ModalFooter className="border-0 justify-content-center">
                {
                    gallery && gallery.hasOwnProperty("published") && gallery.published === "yes" &&
                    <Row className="display-flex-vertical-center" style={{marginTop: -35, marginBottom: 10}}>
                    <span className="custom-radio-btn-container-italic">
                        The content will be published if you press done
                    </span>
                    </Row>
                }
                <Row className="display-flex-vertical-center no-margin">
                    <Col md="6" className="no-padding">
                        <Button color="outline-secondary"
                                onClick={() => {
                                    props.toggle();
                                }}>
                            CANCEL
                        </Button>
                    </Col>
                    <Col md="6" className="no-padding">
                        <Button color="primary"
                                disabled={galleryId === -1}
                                onClick={() => {
                                    props.action(galleryId,gallery)
                                }}>
                            {
                                props.add_video_to_gallery.isFetching
                                    ?
                                    <img
                                        src={assets.loading_white}
                                        alt={"Loading"}
                                        width={26}
                                        height={26}
                                    />
                                    :
                                    "DONE"
                            }

                        </Button>
                    </Col>
                </Row>
            </ModalFooter>
        </Modal>
    );
}

SelectGalleryModal.propTypes = {
    gallery: PropTypes.array.isRequired,
    action: PropTypes.func.isRequired,
    setCreateGalleryModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    add_video_to_gallery: PropTypes.object.isRequired
};

// Specifies the default values for props:
SelectGalleryModal.defaultProps = {
    "video": null,
    action: {
        text: "OK",
        click: () => {
        }
    },
    isOpen: false,
    hideVideoPlayerModal: () => {
    }
};

export default SelectGalleryModal;